import { Component, ViewChild } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { UserServiceResources as us } from 'se-resource-types'
import { EditPersonaComponent } from '../../../lib/edit-persona/edit-persona.component'

const exampleHtml = `
<se-po-edit-persona [profile]="profile" #editPersona></se-po-edit-persona>
<div class="form-value" *ngIf="editPersona">
  <code>
    {{ editPersona.value | json }}
  </code>
</div>
`

const exampleTypescript = `
import { Component, ViewChild } from '@angular/core'
import { EditPersonaComponent } from '@se-po/shared-ui-edit-persona'
import { UserServiceResources as us } from 'se-resource-types'

export class EditPersonaChildExampleComponent {
  @ViewChild('editPersona') public editPersona: EditPersonaComponent

  public profile = {
    access: 'manager',
    persona: {
      first_name: 'Timmy',
      last_name: 'Smith',
      id: 1,
      gender: 'male',
      date_of_birth: '2012-01-02',
      email_addresses: [{ address: 'test@test.com', id: 10 }],
      graduation_year: '2030',
      // eslint-disable-next-line id-blacklist
      phone_numbers: [{ number: '9393333333', id: 11 }]
    },
    relationship: 'other'
  }
}

`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-edit-persona-child-example',
  template,
  styleUrls: ['../edit-persona-docs.component.scss'],
  standalone: false,
})
export class EditPersonaChildExampleComponent extends SeFeDocsExampleComponent {
  @ViewChild('editPersona') public editPersona: EditPersonaComponent

  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  public profile = {
    access: 'manager',
    persona: {
      first_name: 'Timmy',
      last_name: 'Smith',
      id: 1,
      gender: 'male',
      date_of_birth: '2012-01-02',
      email_addresses: [{ address: 'test@test.com', id: 10 }],
      graduation_year: '2030',
      // eslint-disable-next-line id-blacklist
      phone_numbers: [{ number: '9393333333', id: 11 }]
    },
    relationship: 'other'
  }
}
